import { operatorListPath } from '@/common/app/path'
import { Operator } from '@/common/model/operator'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import OperatorForm from '@/components/container/form/modules/admin/operator/OperatorForm'

interface Props {
  operator?: Operator
  onRefetch?: () => void
}

const OperatorEditPage = ({ operator, onRefetch }: Props) => {
  return (
    <>
      <Main type={MainLayoutType.SMALL}>
        <BackButton link={operatorListPath()} />
        <OperatorForm operator={operator} onRefetch={onRefetch} />
      </Main>
    </>
  )
}

export default OperatorEditPage
